import { HttpInterceptorFn, type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, switchMap, type Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

function handleWithAuth$(authToken: string | null, req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let authRequest = req;

  if (authToken && !req.url.includes('/oauth2/') && !req.url.includes('config.json')) {
    authRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`
      }
    });
  }

  return next(authRequest);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // if we don't have an auth token the token has never been acquired or is expired and we
  // have previously loaded a jwt then we need to refresh the token before sending the request
  if (
    !authService.isJWTLoading() &&
    !authService.isCurrentTokenValid() &&
    !req.url.includes('/oauth2/') &&
    !req.url.includes('config.json')
  ) {
    return authService.loadJWT$().pipe(
      switchMap(() => {
        if (authService.isCurrentTokenValid()) {
          return handleWithAuth$(authService.getToken(), req, next);
        }
        // Since version 10 any resolver which returns EMPTY will cancel navigation
        // TODO: test that is OK in regression testing. this may be fine since this
        // is not a resolver
        return EMPTY;
      })
    );
  }

  return handleWithAuth$(authService.getToken(), req, next);
};
